export enum ExpeditionStatus {
  OPEN = 'Open',
  READY = 'Ready',
  ONGOING = 'Ongoing',
  CLOSED = 'Closed',
  DELETED = 'Deleted',
}

export enum UpdateExpeditionStatus {
  OPEN = 'Open',
  OPEN_AND_READY = 'OpenAndReady',
  ALL = 'All',
}